<template>
    <div class="DataCompare bg_fff">
        <!--   头部 title   -->
        <section class="compareTop">
<!--            <img @click="popupVisible = true" class="viewImg" src="../assets/img/compare/list.svg" alt="打开选择弹窗">-->
            <div class="titleBox fs24 flex_box co_fff text_c font_b">
                <p v-if="target1">{{ labelData[0] }}</p>
                <p v-if="target1">{{ labelData[1] }}</p>
            </div>
            <p class="co_fff8 text_c fs12">{{ dateRange }}</p>
        </section>
        <!--  头部导航 -->
        <div class="navBgCommon bg_fff">
            <p class="borderHalf"></p>
            <ul class="commonNav flex_box justify-content_flex-justify">
                <li v-for="item in mainNav" :key="item" :class="{ active: activeNav === item }" @click="activeNav = item">
                    <p class="fs16">{{ item }}</p>
                    <p class="subLine"></p>
                </li>
            </ul>
        </div>
        <!-- 显示替换内容 -->
        <div class="bg_fff" v-if="activeNav === '舆情总览' && target1">
            <LineChart
                v-if="LineChartData"
                :renderData="LineChartData"
                :isCompare="true"
                :labelData="labelData"
                :periodStr="paramsData.dateStr"
                :formatxAxisDate="formatLineChartxAxisDate"
            ></LineChart>
            <p class="cuttingLine"></p>
            <div v-if="target1.spreadStats.fameHealthyMap">
                <TableBar
                    key="healthData"
                    title="地域健康指数"
                    :isMapContent="true"
                    :labelData="labelData"
                    :timeData="paramsData.dateStr"
                    :renderData="{ target1: target1.spreadStats.fameHealthyMap, target2: target2.spreadStats.fameHealthyMap, }"
                    :showDataArr="['health', 'province']"
                ></TableBar>
                <p class="cuttingLine"></p>
            </div>

            <BarChartVertical
                  v-if="target1"
                  key="barChartAffect"
                  chartId="barChartAffect"
                  :hasContent="true"
                  :hasTitle="true"
                  :keyData="[ 'name', 'total' ]"
                  :labelData="labelData"
                  chartTitle="事件数(件)"
                  :timeData="paramsData.dateStr"
                  :entityType="paramsData.type"
                  :renderData="{ target1: target1.spreadStats.broadcastEffect, target2: target2.spreadStats.broadcastEffect, }"/>

        </div>
        <div class="bg_fff" v-if="activeNav === '风险分析' && target1">
            <TableBar  v-if="target1"
                       title="风险类型及等级分布"
                       :renderData="{ target1: target1.general.yinbaoRiskCounts, target2: target2.general.yinbaoRiskCounts, }"
                       :labelData="labelData"
                       key="contentRisks"
                       chartId="contentRisksChart"
                       :setDefaultContent="setRiskContent"
                       chartTitle="监管关注的十类风险"
                       :showDataArr="['count', 'category']"
            ></TableBar>
            <BarChartVertical
                v-if="target1"
                :labelData="labelData"
                :entityType="paramsData.type"
                :chartTitle="paramsData.type =='industry' ? '事件数(件)' : '敏感报道量(篇)'"
                :renderData="{ target1: target1.general.riskLevelCounts, target2: target2.general.riskLevelCounts, }"
                key="barChartRisk"
            />
            <p class="cuttingLine"></p>
            <PieCircleChart
                v-if="target1.general.subCompanyHealth"
                :isDouble="true"
                :entityType="paramsData.type"
                :labelData="labelData"
                :timeData="paramsData.dateStr"
                :renderData="{ target1: target1.general.subCompanyHealth, target2: target2.general.subCompanyHealth, }"/>

        </div>
        <div class="bg_fff" v-if="activeNav === '媒体传播' && target1">
            <BarChartVertical  key="barChartChannel"
                  title="渠道报道倾向"
                  chartId="barChartChannel"
                  chartTitle="报道量(篇)"
                  :hasContent="true"
                  :isChannel="true"
                  :hasTitle="true"
                  :keyData="[ 'name', 'total' ]"
                  :labelData="labelData"
                  :timeData="paramsData.dateStr"
                  :entityType="paramsData.type"
                  :renderData="{ target1: target1.spreadStats.channelTendency, target2: target2.spreadStats.channelTendency, }"/>
            <CommonTable  :onlyTable="true" :tableData="tableData" tableName="hasPercent table2" :hasPercentBar="true"></CommonTable>
            <p v-if="false" class="cuttingLine"></p>
            <div class="articleBox ">
                <p class="homeComTitle hasLine mt16">
                    <span class="titleLine"></span>
                    <span class="flex_1">重点事件</span>
                </p>

                <section class="fs14 co_333 text_l event_desc">
                    <p v-if="target1.mainEvent" class="">
                        {{ target1.name }}：{{paramsData.dateStr }}，本{{entityLabel}}发生重点事件如下，其中《<a :href=target1.mainEvent.uri class="co_333" target="_blank"><b>{{ target1.mainEvent.title }}</b></a>》风险等级最高，需重点关注。
                    </p>
                    <p v-if="target2.mainEvent" class="">
                        {{ target2.name }}：{{ paramsData.dateStr }}，本{{entityLabel}}发生重点事件如下，其中《<a :href=target2.mainEvent.uri class="co_333" target="_blank"><b>{{ target2.mainEvent.title }}</b></a>》风险等级最高，需重点关注。
                    </p>
                </section>

                <div class="titleImgBox flex_box justify-content_flex-justify mt20 ">
                    <img class="titleImg" src="../assets/img/icon/negativeTop5.png" alt="敏感标题">
                    <div class="nav">
                         <span class="nav-item" v-for="(item, index) in labelData" :key="item" @click="changeData(index)" :class="{ 'nav-item-active': activeIndex === index }">{{ item }}</span>
                    </div>
                </div>
                <ArticleList
                    :assignData="assignNegative"
                    :onlyList="true"
                    :noIndex="false"
                    entity="event"
                    :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                </ArticleList>
                <div class="titleImgBox flex_box justify-content_flex-justify mt28">
                    <img class="titleImg" src="../assets/img/icon/positiveTop5.png" alt="正面标题">
                </div>
                <ArticleList
                    addClass="hideLastBorder"
                    :assignData="assignPositive"
                    :assignPositive="true"
                    :onlyList="true"
                    :noIndex="false"
                    entity="event"
                    :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                </ArticleList>
            </div>
        </div>
        <LoadingPage :loading="loading"/>
        <!-- 底部 操作按钮 -->
        <div class="exportFooter fs16 bg_deepBule co_fff" @click="gotoExportPage()">导出</div>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import utils from "@/util/common";
import common from "@/util/common";


export default {
    name: "DataCompare",
    components: {
        LineChart(render){ require(["@/components/chart/LineChart"], render) },
        TableBar(render){ require(["@/components/entity/TableBar"], render) },
        BarChartVertical(render){ require(["@/components/chart/BarChartVertical"], render) },
        PieCircleChart(render){ require(["@/components/chart/PieCircleChart"], render) },
        CommonTable(render){ require(["@/components/entity/CommonTable"], render) },
        ArticleList(render){ require(["@/components/entity/ArticleList"], render) },
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },

        // ChoosePopup(render){ require(["@/components/common/ChoosePopup"], render) },
    },
    data() {
        return {
            formatLineChartxAxisDate: true,
            loading: false,
            mainNav: [ '舆情总览', '风险分析', '媒体传播', ],
            activeNav: '舆情总览',
            paramsData: {
                startDate: moment().subtract(3, 'day').startOf('day').valueOf(),
                endDate: moment().endOf('day').valueOf(),
                targetId1: '银行',
                targetId2: '证券',
                type: 'industry',
                dateStr: '今日',
            },
            LineChartData: null, // 舆情健康指数 趋势 渲染数据
            labelData: null, // 舆情健康指数 title
            target1: null, // 对比数据
            target2: null, // 对比数据
            startTime: null, // 对比开始时间
            endTime: null, // 对比结束时间
            tableData: null, // 媒体传播 对比 table
            assignNegative: null, // 指定的负面 文章数据
            assignPositive: null, // 指定的正面 文章数据
            activeIndex: 0, // 当前选中
            popupVisible: false, // 是否显示选择弹窗

            token: utils.getCookie("xinhuaToken") || this.$route.query.xinhuaToken,
            imageUrl: null,
            setRiskContent: null, // 设置 风险等级对比 文案
            entityLabel: "企业",
            unitKey: "篇",
            unitLabel: "敏感事件报道",
            dateRange: ""
        }
    },
    mounted() {
        this.paramsData = this.$route.query;
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true;
            this.target1 = null;
            this.target2 = null;
            let res = await this.baseApi.compare(this.paramsData);
            if(res !== 'confirm') {
                let { target1, target2, startDate, endDate } = res;

                if(this.paramsData.type == "industry"){
                    this.entityLabel = "行业"
                    this.unitKey = "件";
                    this.unitLabel=  "敏感事件";
                    target1.name = utils.convertEntityName(target1.name);
                    target2.name = utils.convertEntityName(target2.name)
                }

                this.LineChartData = {
                    each: target1.healths || [],
                    each1: target2.healths || [],
                    mainChief: _.get(target1, "eventTop5.negative[0]", null),
                    mainChief1: _.get(target2, "eventTop5.negative[0]", null),
                }

                target1.spreadStats.channelTendency = _.orderBy(target1.spreadStats.channelTendency, ["level"], ["desc"]);
                target2.spreadStats.channelTendency = _.orderBy(target2.spreadStats.channelTendency, ["level"], ["desc"]);
                this.labelData = [target1.name, target2.name]
                this.target1 = target1;
                this.target2 = target2;
                this.startTime = startDate;
                this.endTime = endDate;
                this.dateRange = common.dateStrRange(startDate, endDate);

                let table1 = target1.spreadStats.channelTendency,
                    table2 = target2.spreadStats.channelTendency,
                    total1 = _.sumBy(table1, 'total'),
                    total2 = _.sumBy(table2, 'total'),
                    negative1 = _.sumBy(table1, 'negative'),
                    negative2 = _.sumBy(table2, 'negative');


                this.tableData = {
                    head: [
                        {name: `对比${this.entityLabel}`, key: "item"},
                        {name: '敏感报道占比', key: 'percent'},
                    ],
                    body: [
                        { item: target1.name, percent: utils.formatPercentAndCeil(negative1, total1), },
                        { item: target2.name, percent: utils.formatPercentAndCeil(negative2, total2), className: 'bg_f29e01', },
                    ]
                }
                this.assignNegative = target1.eventTop5.negative;
                this.assignPositive = target1.eventTop5.positive;

                this.setContent(target1, target2)
            }

            this.loading = false;
        },
        setContent(target1, target2) {
            let riskTotal1 = _.sumBy(target1.general.riskLevelCounts, 'count'),
                riskTotal2 = _.sumBy(target2.general.riskLevelCounts, 'count');

            let target1ContentRiskMap = _.get(target1, "general.yinbaoRiskCounts[0]", null);
            let target2ContentRiskMap = _.get(target2, "general.yinbaoRiskCounts[0]", null);
            let cat1 = "", cat2="", count1= 0 ,count2 = 0;
            if(target1ContentRiskMap){
                cat1 = target1ContentRiskMap.category;
                count1 = target1ContentRiskMap.count;
            }
            if(target2ContentRiskMap){
                cat2 = target2ContentRiskMap.category;
                count2 = target2ContentRiskMap.count;
            }
            // let  contentImportant1 = _.get(target1, "general.riskLevelCounts[0].count", 0) + _.get(target1, "general.riskLevelCounts[1].count", 0),
            //     contentImportant2 = _.get(target2, "general.riskLevelCounts[0].count", 0) + _.get(target2, "general.riskLevelCounts[1].count", 0);

            this.setRiskContent =  `<p>${ target1.name }：${this.paramsData.dateStr}，本${this.entityLabel}${this.unitLabel}${ riskTotal1 }${this.unitKey}，`;

            if(cat1){
                this.setRiskContent += `最多的风险类别是【${ cat1 }】，相关${this.unitLabel}${ count1 }${this.unitKey}，占比${ utils.formatPercentAndCeil(count1, riskTotal1) }%。</p>`
            } else {
                this.setRiskContent += `暂无风险点。</p>`;
            }

            this.setRiskContent += `<p>${ target2.name }：${this.paramsData.dateStr}，本${this.entityLabel}${this.unitLabel}${ riskTotal2 }${this.unitKey}，`;

            if(cat2){
                this.setRiskContent += `最多的风险类别是【${ cat2 }】，相关${this.unitLabel}${ count2 }${this.unitKey}，占比${ utils.formatPercentAndCeil(count2, riskTotal2) }%。</p>`
            } else {
                this.setRiskContent += `暂无风险点。</p>`;
            }
        },
        changeData(index) {
            this.activeIndex = index;
            let dataName = 'target' + (index + 1);
            this.assignNegative = this[dataName].eventTop5.negative;
            this.assignPositive = this[dataName].eventTop5.positive;
        },
        closeChoose(data) {
            if(data) {
                let { compareType, activeTime, activeIndustry } = data;
                this.paramsData.startDate = utils.getTimeName(activeTime);
                this.paramsData.dateStr = activeTime;
                this.paramsData.type = compareType;
                this.paramsData.targetId1 = activeIndustry[0];
                this.paramsData.targetId2 = activeIndustry[1];
                this.getData();
            }
            this.popupVisible = false;
        },
        gotoExportPage() {
            this.$router.push({ path: '/exportCompare', query: this.$route.query });
        }
    }
}
</script>

<style lang="scss" scoped>
.DataCompare {
    padding-bottom: 60px;
    .compareTop {
        width: 100%;
        height: 84px;
        background-image: url("../assets/img/compare/CompareTop.png");
        background-size: 100% 100%;
        position: relative;
        padding: 18px 0 10px;
        .viewImg {
            width: 16px;
            position: absolute;
            top: 12px;
            right: 16px;
        }
        .titleBox {
            margin-bottom: 8px;
            p { width: 50%; line-height: 33px; }
        }
    }
    .articleBox{
        font-family: PingFangSC-Regular;
        .homeComTitle { padding: 0 20px; }
        .event_desc{
            padding: 12px 16px 0px 16px;
        }
        .titleImgBox {
            padding: 0 20px;
            .titleImg { width: 80px; }
            .nav {
                display: flex;
                height: 24px;
                line-height: 24px;
            }

            .nav-item {
                text-align: center;
                padding: 0px 5px;
                font-size: 12px;
                color: #b0b0b0;
                position: relative;
            }

            .nav-item::before {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba(0, 0, 0, 0.1);
                transform: skewX(-5deg);
                border-right: 1px solid #ededed;
            }

            .nav-item-active {
                position: relative;
                color: #fff;
                z-index: 2;
            }

            .nav-item-active::before {
                background: #386ccf;
                z-index: -1;
            }
        }

    }

    .footControlBox {
        width: 100%;
        height: 48px;
        line-height: 48px;
        p {
            width: 50%;
            &:nth-child(1) {
                background-color: #F29E01;
            }
            &:nth-child(2) {
                background-color: #376CCF;
            }
        }
    }

}
</style>